import React, {useState, useEffect} from 'react';

const Select = (props) => {
    const { option, answer, setAnswer, isSingle, onAnswer, questionIndex } = props;
    const [ selected, setSelected ] = useState(false);

    useEffect(() => {
        if (isSingle) {
            if (answer === option.value) {
                setSelected(true);
            } else {
                setSelected(false);
            }
        }
    }, [answer])

    const onClick = () => {
        if (isSingle) {
            if (selected) {
                setAnswer(null);
                if (onAnswer) {
                    onAnswer(null, questionIndex);
                }
            } else {
                setAnswer(option.value);
                if (onAnswer) {
                    onAnswer(option.value, questionIndex)
                }
            }
        } else {
            if (selected) {
                setSelected(false);
                var arr = answer.filter(a => a !== option.value);
                setAnswer(arr);
                if (onAnswer) {
                    onAnswer(arr, questionIndex);
                }
            } else {
                setSelected(true);
                var arr = answer;
                arr.push(option.value);
                setAnswer(arr);
                if (onAnswer) {
                    onAnswer(arr, questionIndex);
                }
            }
        }
    }

    return (
        <div 
            onClick={onClick}
            className={selected ? "live-choice-selected" : 'live-choice'}
            style={{height: 100}}
        >
            {option.label}
        </div>
    )
}

export default Select;